import { render } from "./AssetGroupsAveragesView.vue?vue&type=template&id=9a65576a&scoped=true&ts=true"
import script from "./AssetGroupsAveragesView.vue?vue&type=script&lang=ts"
export * from "./AssetGroupsAveragesView.vue?vue&type=script&lang=ts"

import "@/assets/scss/asset-view-style.scss?vue&type=style&index=0&lang=scss&external"
import "./AssetGroupsAveragesView.vue?vue&type=style&index=1&id=9a65576a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a65576a"]])

export default __exports__